<template>
	<main id="event">
		<div id="container">
			<form style="height: 400px !important;">
				<h2>Événement en cours</h2>
				<pools_radio_input v-on:validateField="validateExtraInput" v-bind:params="getEventsParams()" v-bind:answer2="selectedEvent+''" v-bind:lang="lang"></pools_radio_input>
				<button v-on:click.self.stop.prevent="selectEvent" v-bind:class="selectedEvent >= 0 ? 'selected' : ''">Sélectionner</button>

				 <ul>
					<li  >
						<button  class="selected button2" v-if="editable()" v-on:click.self.stop.prevent="editEvent">Modifier</button>
						<button  class="selected button2" v-on:click.self.stop.prevent="_showCreateNewEvent">Créer un événement</button>
					</li>
				</ul>

			</form>
			<form v-if="showCreateNewEvent">
				<h2 v-if="eventMethod == 'new'">Nouvel événement</h2>
				<h1 v-else>Modification d'un événement</h1>
				<ul v-if="isAuthTOCreateEvent">
				<li>
					<label>Nom de l'événement:</label>
					<input type="text" v-model="newEvent.name" placeholder="Evénement" id="name" required="true">
				</li>
				<li>
					<label>Date de début de l'événement:</label>
					<input type="date" v-model="newEvent.startDate" v-bind:min="minDate" v-on:change="checkEndDate">
				</li>
				<li>
					<label>Date de fin de l'événement:</label>
					<input type="date" v-model="newEvent.endDate" v-bind:min="newEvent.startDate">
				</li>
				<li>
					<label>Url de l'événement:</label>
					<input type="url" v-model="newEvent.url" placeholder="https://example.com" id="url" v-on:input="checkURL($event)" v-on:change="checkURL($event)">
    				<div style = "color : red" v-if="!isValidUrl && errUrl">Veuillez saisir un URL</div>
				</li>
				</ul>
				<ul v-else>
					<li>
						<label>Mot de passe:</label>
						<input type="password" v-model="pwCreateEvent" placeholder="Mot de passe" id="pwCreateEvent" required="true">
					</li>
				</ul>
				<button class="selected" v-on:click.self.stop.prevent="resetForm" v-if="eventMethod != 'new'">Annuler</button>
				<button v-if="isAuthTOCreateEvent" v-on:click.self.stop.prevent="createNewEvent" id="create_event">{{createButtonValue()}}</button>
			</form>
		</div>
	</main>
</template>


<script>
import pools_radio_input from '@/components/candidate_forms/pools_radio_input.vue';
import genId from '@/libs/randomIds.js';
import lib from '@/libs/main.js';
export default {
	name: 'eventSelection',
	data() {
		return {
			newEvent : {
				name : '',
				startDate : '',
				endDate : '',
				url : ''
			},
			selectedEvent : '-1',
			_idSelected : '',
			eventMethod : 'new',
			isAuthTOCreateEvent: false,
			pwCreateEvent: '',
			isValidUrl : false,
			isValidName : false,
			showCreateNewEvent: false,
			errUrl:''
		};
	},
	props : ['events', 'api', 'lang'],
	components : {
		pools_radio_input
	},
	computed : {
		minDate : function(){
			let minDate = lib.dateToInput(new Date());
			if(!this.newEvent.startDate){
				this.newEvent.startDate = minDate; // Works cause computed properties are cached by Vue.js
				this.newEvent.endDate = minDate;
			}
			return minDate;
		}
	},
	methods : {
		_showCreateNewEvent: function(){
			this.showCreateNewEvent = true;
			this.selectedEvent = -1;
			this.newEvent = {
				name : '',
				startDate : '',
				endDate : '',
				url : ''
			}
		},
		validateExtraInput : function(name, value) {
			const i = parseInt(value);
			if(!Number.isInteger(i)) this.selectedEvent = -1;
			else  this.selectedEvent = i;
			if(this.selectedEvent>-1) this.showCreateNewEvent = false;
		},
		getEventsParams: function(){
			let output = {
				"name": "eventsName",
				"label": {
					"fr": "Sélectionner un événement",
					"en": "Sélectionner un événement"
				},
				"compulsory": true,
				"unique": true,
				"options": []
			}
			for(let i = 0; this.events && i < this.events.length; i++){
				output.options.push({
						"label": {
							"fr": this.events[i].name,
							"en": this.events[i].name
						},
						"value": i+"",
				});
			}
			return output;
		},
		createNewEvent : function(){
			if( !this.isAuthTOCreateEvent || !this.newEvent.name.trim() || !this.isValidUrl) return false;
			if(this.eventMethod == 'new') {
				let newEvent = {name : this.newEvent.name.trim(), startDate : this.newEvent.startDate, endDate : this.newEvent.endDate, _id : genId()};
				if(this.newEvent.url) newEvent.url = this.newEvent.url;
				this.events.push(newEvent);
				this.selectedEvent = this.events.length - 1;
				this.api.addNewEvent(newEvent);
				lib.askSyncData();
			} else {
				let _index = this.events.findIndex(e => e._id == this._idSelected);
				if(_index > -1) {
					if(this.events[_index].source) return false;
					this.events[_index] = {name : this.newEvent.name.trim(), startDate : this.newEvent.startDate, endDate : this.newEvent.endDate, _id : this.events[_index]._id};
					if(this.newEvent.url) this.events[_index].url = this.newEvent.url;
					this.selectedEvent = _index;
					this.api.editEvent(this.events[_index]);
				}
			}
			this.showCreateNewEvent = false;
			this.isAuthTOCreateEvent= false,
			this.pwCreateEvent= '',
			this.resetForm();
		},
		checkEndDate : function(){
			if(new Date(this.newEvent.startDate) > new Date(this.newEvent.endDate)) this.newEvent.endDate = this.newEvent.startDate;
		},
		checkURL:function(e){
			const regex= new RegExp(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/)
			if(!e.target.value || !e.target.value.trim().length) this.isValidUrl = false;
			else this.isValidUrl =  regex.test(e.target.value);
			if(!this.isValidUrl) this.errUrl = "Veuillez saisir un URL"
			else  this.errUrl = '';
		},
		editEvent : function(){
			let event = this.events[this.selectedEvent];
			this.selectedEvent = -1;
			this.eventMethod = 'edit';
			this._idSelected = event._id;
			this.newEvent.name = event.name;
			this.newEvent.startDate = event.startDate;
			this.newEvent.endDate = event.endDate;
			this.newEvent.url = event.url;
			this.showCreateNewEvent = true;
			this.isValidUrl = true;

		},
		selectEvent : function(){
			let event = this.events[this.selectedEvent];
			this.$emit('newEventSelected', event);
		},
		createButtonValue : function(){
			return !this.isAuthTOCreateEvent ? 'Valider' : this.eventMethod == "new" ? "Créer" : "Modifier";
		},
		resetForm : function(){
			this.newEvent.name = '';
			this.newEvent.startDate = this.minDate;
			this.newEvent.endDate = this.minDate;
			this.newEvent.url = '';
			if(this.eventMethod == 'edit') this.eventMethod = 'new';
			this.showCreateNewEvent = false;
			this.isAuthTOCreateEvent= false;
			this.pwCreateEvent= '';
		},
		editable : function() {
			const selection = this.selectedEvent;
			if(selection == -1) return false;
			const event = this.events[this.selectedEvent];
			return !event.source; //Only remote source are editable
		},
		getEventName : function(event) {
			const prefixMap = {offer : 'Offre'};
			let eventName = event.name || '???';

			if(event.source && prefixMap[event.source]) eventName = `[${prefixMap[event.source]}] ${eventName}`;

			return eventName;
		}
	},
	watch : {
		'newEvent.name' : function(newVal) {
			let normalized = newVal.trim();
			const button = document.getElementById("create_event");
			this.isValidName = normalized.length;
			if(!this.isValidName || !this.isValidUrl) button.classList.remove("selected");
			else button.classList.add("selected");
		},
		'newEvent.url' : function(newVal){
			const button = document.getElementById("create_event");
			if(!this.isValidName || !this.isValidUrl) button.classList.remove("selected");
			else button.classList.add("selected");
		},
		'newEvent.startDate': function(newVal){
			const button = document.getElementById("create_event");
			if(!this.isValidName || !this.isValidUrl) button.classList.remove("selected");
			else button.classList.add("selected");
		},
		'newEvent.endDate': function(newVal){
			const button = document.getElementById("create_event");
			if(!this.isValidName || !this.isValidUrl) button.classList.remove("selected");
			else button.classList.add("selected");
		},
		'pwCreateEvent' : function(newVal) {
			let normalized = newVal.trim();
			const button = document.getElementById("create_event");
			this.isValidName = normalized.length;
			this.isAuthTOCreateEvent = newVal === '2016';
			if(!this.isAuthTOCreateEvent) button.classList.remove("selected");
			else button.classList.add("selected");
		}
	},
	created : function(){
		var event = localStorage.getItem("currentEvent");
		if(event){
			try{
				event = JSON.parse(event);
				this.$emit('newEventSelected', event);
			}catch(e){}
		}
	}
};
</script>

<style lang="less">
@import '../assets/less/conf.import.less';
.button2{
	background-color: #ffff !important;
    color: black !important;
    box-shadow: unset !important;
    text-decoration: underline !important;
}
#event form{
	text-align: center;
	li{
		position: relative;
		margin-top: 2vh;
		margin-bottom: 2vh;
		&:last-of-type {
			margin-bottom: 0;
		}
		input{
			margin-left: 65%;
			width: 35%;
			display: inline-block;
		}
		&:first-of-type{
			input{
				margin-left: 55%;
				width: 45%;
			}
		}
	}
}
#event select{
	display: block;
	width: 60%;
	margin: 5% auto 0 auto;
}
#event label{
	position: absolute;
	left: 0;
	margin-top: 2%;
}
#event button{
	&:last-of-type{
		margin-left: 5%;
	}
}
#event #container {
	max-height: 85%;
	position: relative;
	top: 50%;
	left: 50%;
	max-width: 600px;
	transform: translate(-50%, -50%);
	overflow-y: auto;
	padding: 2vh;
}
#event form {
	width: 100%;
	transform: none;
	left: 0;
	top: 0;
	padding: 2% 8%;
	&:last-of-type {
		margin-top: 4vh;
	}
}

</style>



// WEBPACK FOOTER //
// src/components/eventSelection.vue